const integrityCompliance = () => import("@/views/integrityCompliance/IntegrityCompliance");
const integrityComplianceMain = () => import("@/views/integrityCompliance/IntegrityComplianceInit");

const integrityComplianceRoutes = [
  {
    path: "integrityCompliance",
    name: "IntegrityCompliance",
    redirect: {
      name: "IntegrityCompliance Main"
    },
    component: integrityCompliance,
    children: [
      {
        path: "Main",
        name: "IntegrityCompliance Main",
        component: integrityComplianceMain
      }
    ]
  }
];

export default integrityComplianceRoutes;
